import { Component, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-iframe-wrapper',
  template: `<div class="iframe-wrapper"></div>`,
  styleUrls: ['./iframe-wrapper.component.scss'],
  standalone:true
})
export class IframeWrapperComponent implements OnChanges {
  @Input() html!: string; // сюда передаётся HTML iframe

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['html'] && this.html) {
      const container = this.el.nativeElement.querySelector('.iframe-wrapper');
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      // Создаем временный DOM элемент, чтобы распарсить HTML
      const temp = document.createElement('div');
      temp.innerHTML = this.html;
      const iframeEl = temp.querySelector('iframe');

      if (iframeEl) {
        const iframe = this.renderer.createElement('iframe');
        this.renderer.setAttribute(iframe, 'src', iframeEl.getAttribute('src') || '');
        this.renderer.setStyle(iframe, 'width', '100%');
        this.renderer.setStyle(iframe, 'height', '100%');
        this.renderer.setStyle(iframe, 'border', 'none');

        this.renderer.appendChild(container, iframe);
      }
    }
  }
}
